// extracted by mini-css-extract-plugin
module.exports = {"token":"MessagesUpload_token__1wqym"};